module.exports = __webpack_public_path__ + "f2388092f3ecfee20a087596b0a0404c.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/containers/OurTeam/our-team-intro.jpg
// module id = 1220
// module chunks = 0